import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTimes} from '@fortawesome/free-solid-svg-icons'

class ImageCardDark extends Component {

    state = {
        viewImage: false,
    }

    callModal = () => {
        const { viewImage } = this.state;
        if (viewImage) {
            this.setState({
                viewImage: false,
            })
        }
        else {
            this.setState({
                viewImage: true,
            })
        }
    }

    render() {

        const { image } = this.props;
        const { viewImage } = this.state;
        const close = <FontAwesomeIcon icon={faTimes} />

        return (
            <div>
                <div
                    className="card border-0 h-100 shadow "
                >
                    <div className="card-img-top">
                        <img
                            src={image.imageURL}
                            alt={image.title}
                            className="img-fluid"
                        />
                    </div>
                    <div className="card-body text-center darkCard py-0">
                        <div className="card-title fs-4 pb-1 pt-2">
                            {image.title}
                        </div>
                        <div className="stretched-link mymodal" onClick={this.callModal}></div>
                    </div>
                </div>
                <Modal show={viewImage} onHide={this.callModal} size="lg" contentClassName="border-0 font-monospace">

                    <Modal.Body className="lightCard px-0 py-0">
                        <div className="pb-2">
                            <button className="btn float-end" onClick={this.callModal}>
                                {close}
                            </button>
                        </div>
                        <div className="text-center">
                            <img src={image.imageURL} alt={image.title} className="img-fluid pt-2" />
                        </div>
                        <div className="py-4 fs-2 text-center">{image.title}</div>
                    </Modal.Body>

                </Modal>
            </div>
        )
    }
}

export default ImageCardDark;
